import { createIconComponent } from '../../factory/create-icon-component';
export const HeartIcon = createIconComponent(
  'HeartIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21C13 21 22 16.0002 22 9.0004C22 5.50054 19 3.04402 16 3.00062C14.5 2.97891 13 3.50062 12 5.00056C11 3.50062 9.47405 3.00062 8 3.00062C5 3.00062 2 5.50054 2 9.0004C2 16.0002 11 21 12 21Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
